const expertRouter = [{
  path: '',
  redirect: 'scoreList'
},
  {
    path: 'scoreList',
    meta: {title: '社会组织评估填报系统'},
    component: () => import ('../views/mobile/expert/scoreList'),
  },
  {
    path: 'user',
    meta: {title: '社会组织评估填报系统'},
    component: () => import ('../views/mobile/expert/user'),
  },
  {
    path: 'attendOrg/:id',
    meta: {title: '社会组织评估填报系统'},
    component: () => import ('../views/mobile/expert/attendOrg'),
  },
  {
    path: 'scoreFrist/:oid/:sid',
    meta: {title: '社会组织评估填报系统'},
    component: () => import ('../views/mobile/expert/scoreFrist'),
  },
  {
    path: 'scoreTwo/:oid/:sid/:id',
    meta: {title: '社会组织评估填报系统'},
    component: () => import ('../views/mobile/expert/scoreTwo'),
  },
  {
    path: 'scoreThree/:oid/:sid/:id',
    meta: {title: '社会组织评估填报系统'},
    component: () => import ('../views/mobile/expert/scoreThree'),
  },
  {
    path: 'scoreFour/:oid/:sid/:id',
    meta: {title: '在线签字'},
    component: () => import ('../views/mobile/expert/scoreFour'),
  },
  {
    path: 'scoreFive',
    meta: {title: '社会组织评估填报系统'},
    component: () => import ('../views/mobile/expert/scoreFive'),
  },
]
export default expertRouter
